import React, {PropsWithChildren} from 'react'
import {Button, ButtonPriority, HoverStyles, PaddingModes} from 'wix-ui-tpa/cssVars'

import {useGlobalButtonStyle, GlobalButtonStyleParams} from '../../../../utils/useGlobalButtonStyle'

import {classes, st} from './ReserveButton.st.css'
import {reserveButtonDataHooks} from './constants'

interface Props {
  onClick?: () => void
  width?: number
  className?: string
  type?: 'button' | 'submit'
  globalStyleParams: GlobalButtonStyleParams
}

export const ReserveButton = ({
  onClick,
  children,
  width,
  className,
  type = 'submit',
  globalStyleParams,
}: PropsWithChildren<Props>) => {
  const globalButtonStyle = useGlobalButtonStyle(globalStyleParams)

  return (
    <div className={st(classes.container)}>
      <Button
        className={st(classes.root, className)}
        priority={ButtonPriority.primary}
        hoverStyle={HoverStyles.underline}
        paddingMode={PaddingModes.explicitPaddings}
        onClick={onClick}
        type={type}
        style={{
          ...globalButtonStyle,
          ...(width ? {width: `${width}px`} : {}),
        }}
        data-hook={reserveButtonDataHooks.button()}
      >
        {children}
      </Button>
    </div>
  )
}
